import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=4feb0f5d&scoped=true&"
import script from "./CartFooter.vue?vue&type=script&lang=js&"
export * from "./CartFooter.vue?vue&type=script&lang=js&"
import style0 from "../../styles/cart-footer.css?vue&type=style&index=0&id=4feb0f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb0f5d",
  null
  
)

export default component.exports